import { PaletteColor } from '@mui/material'

declare module '@mui/material/styles' {
	interface Palette {
		gameOppositeDay: Palette['primary']
	}

	interface PaletteOptions {
		gameOppositeDay?: PaletteOptions['primary']
	}
}

declare module '@mui/material/Alert' {
	interface AlertPropsColorOverrides {
		gameOppositeDay: true
	}
}

export const gameOppositeDayColor = {
	main: '#349DE9',
	light: '#DCEFFE',
} as PaletteColor
